import styled from "styled-components";

export const Background = styled.div`
  display: flex;
  justify-content: space-between;

  padding: 1.5rem;
`;
